import { getModule } from 'vuex-module-decorators'
import SystemtModule from '@/store/SystemModule'
import moment from 'moment'
// @ts-ignore
import { Md5 } from 'ts-md5/dist/md5'
import BigNumber from 'bignumber.js'
import Company from './Company'
import OpportunityActivity from './OpportunityActivity'
import Model from './interface/Model'
import ModelWithFiles from './interface/ModelWithFiles'
import Api from './Api'
import { LostCategories } from './interface/Common'
import ModelFile from './ModelFile'
import PaginateOptions from './interface/PaginateOptions'
import WebMessage from './WebMessage'
import OpportunityAmountChange from './OpportunityAmountChange'
import SelectOption from './interface/SelectOption'
import MediaPlan from './MediaPlan'
import DatePickerDate from './DatePickerDate'

export default class Opportunity extends ModelWithFiles {
  protected api_settings = {
    save_mode: 'form',
    paths: {
      singular: 'opportunities' as string | null,
      plural: 'opportunities' as string | null,
    },
  }

  public get user(): any {
    const { user } = getModule(SystemtModule)
    return user ?? {}
  }

  public id: any = null

  public holding_id: any = null

  public agency_id: any = null

  public agency: Company | any = null

  public station_id: any = null

  public station: Company | any = null

  public advertiser_id: any = null

  public advertiser: Company | any = null

  public sales_management_id: any = this.user.manager_id

  public sales_rep_id: any = this.user.id

  public account_manager_id: any = null

  public name: any = null

  public status: any = 'prospecting'

  public is_cancelled: boolean = false

  public is_political: boolean = false

  public percentage: any = 2

  public types: string[] = ['ssl']

  public source: any = 'outbound'

  public amount: any = 0

  public original_amount: any = 0

  public start_at: any = moment().startOf('month').add(1, 'month').format('YYYY-MM-DD')

  public end_at: any = moment().endOf('month').add(1, 'month').format('YYYY-MM-DD')

  public closed_at: string = ''

  public company_contact_ids: any = []

  public activities: OpportunityActivity[] = []

  public preplan_ids: any = []

  public media_plan_ids: any = []

  public main_media_plan_id: any = null

  public created_at: any = null

  public force_new_business: string = 'auto'

  public is_new_business: boolean = false

  public force_new_account: string = 'auto'

  public is_new_account: boolean = false

  public media_plan_overwrite: boolean = false

  public allow_media_plan_overwrite: boolean = false

  public secondary_sales_rep_ids: any = []

  public revenue_details: any = null

  public teams: any = []

  /**
   * @deprecated
   * remove later, its only for ref
   */
  public static old_opportunity_status: any = [
    {
      name: 'Targeting',
      value: 10,
      code: 'targeting',
    },
    {
      name: 'Prospecting',
      value: 11,
      code: 'prospecting',
    },
    {
      name: 'Discovery',
      value: 15,
      code: 'discovery',
    },
    {
      name: 'Repeat Business',
      value: 20,
      code: 'repeat_business',
    },
    {
      name: 'Pitched',
      value: 30,
      code: 'pitched',
    },
    {
      name: 'Consideration',
      value: 50,
      code: 'consideration',
    },
    {
      name: 'Expected',
      value: 75,
      code: 'expected',
    },
    {
      name: 'Processing',
      value: 90,
      code: 'processing',
    },
    {
      name: 'Won',
      value: 100,
      code: 'won',
    },
    {
      name: 'Lost',
      value: 0,
      code: 'lost',
    },
    // {
    //   name: 'Full Order CXL',
    //   value: 0,
    //   code: 'full_order_cxl',
    // },
  ]

  public static opportunity_status: any = [
    {
      name: 'Prospecting',
      weight: 0,
      value: 2,
      code: 'prospecting',
    },
    {
      name: 'Discovery',
      weight: 10,
      value: 10,
      code: 'discovery',
    },
    {
      name: 'Presenting',
      weight: 20,
      value: 20,
      code: 'presenting',
    },
    {
      name: 'Proposing',
      weight: 40,
      value: 40,
      code: 'proposing',
    },
    {
      name: 'Negotiating',
      weight: 60,
      value: 60,
      code: 'negotiating',
    },
    {
      name: 'Expected',
      weight: 80,
      value: 80,
      code: 'expected',
    },

    {
      name: 'Processing',
      weight: 100,
      value: 95,
      code: 'processing',
    },
    {
      name: 'Won',
      weight: 100,
      value: 100,
      code: 'won',
    },
    {
      name: 'Lost',
      value: 0,
      weight: 0,
      code: 'lost',
    },
  ]

  public static opportunity_status_text: any = [
    {
      name: 'Prospecting',
      value: 'prospecting',
      code: 'prospecting',
    },
    {
      name: 'Discovery',
      value: 'discovery',
      code: 'discovery',
    },
    {
      name: 'Presenting',
      value: 'presenting',
      code: 'presenting',
    },
    {
      name: 'Proposing',
      value: 'proposing',
      code: 'proposing',
    },
    {
      name: 'Negotiating',
      value: 'negotiating',
      code: 'negotiating',
    },
    {
      name: 'Expected',
      value: 'expected',
      code: 'expected',
    },
    {
      name: 'Processing',
      value: 'processing',
      code: 'processing',
    },
    {
      name: 'Won',
      value: 'won',
      code: 'won',
    },

    {
      name: 'Lost',
      value: 'lost',
      code: 'lost',
    },
  ]

  /**
   * @deprecated
   * remove later, its only for ref
   */
  public static old_opportunity_status_text: any = [
    {
      name: 'Targeting',
      value: 'targeting',
      code: 'targeting',
    },
    {
      name: 'Prospecting',
      value: 'prospecting',
      code: 'prospecting',
    },
    {
      name: 'Discovery',
      value: 'discovery',
      code: 'discovery',
    },
    {
      name: 'Repeat Business',
      value: 'repeat_business',
      code: 'repeat_business',
    },
    {
      name: 'Pitched',
      value: 'pitched',
      code: 'pitched',
    },
    {
      name: 'Consideration',
      value: 'consideration',
      code: 'consideration',
    },
    {
      name: 'Expected',
      value: 'expected',
      code: 'expected',
    },
    {
      name: 'Processing',
      value: 'processing',
      code: 'processing',
    },
    {
      name: 'Won',
      value: 'won',
      code: 'won',
    },
    {
      name: 'Lost',
      value: 'lost',
      code: 'lost',
    },
  ]

  public get editable_status() {
    return Opportunity.opportunity_status
      .filter((status: any) => !['won', 'lost'].includes(status.code))
      .map((status: any) => status.code)
  }

  public static option_list: any = {
    lost_categories: LostCategories,
    lead_sources: [
      {
        name: 'lead_source',
        value: 'lead_source',
      },
    ],
    mrgs: [
      {
        name: 'Zone',
        value: 'zone',
      },
      {
        name: 'LMA',
        value: 'lma',
      },
    ],
  }

  public tasks: any = {
    request_max_avail_plan: false, // at the backend, this will create a task for the sales rep
    request_media_plan: false,
  }

  public metadata: any = {
    overwride_distribution: false,
    product_revenue_distribution: {
      ssl: 0,
      ccl: 0,
      home: 0,
    },
    period_revenue_distribution: {
      q1: 0,
      q2: 0,
      q3: 0,
      q4: 0,
    },
    monthly_revenue_distribution: {
      jan: 0,
      feb: 0,
      mar: 0,
      apr: 0,
      may: 0,
      jun: 0,
      jul: 0,
      aug: 0,
      sep: 0,
      oct: 0,
      nov: 0,
      dec: 0,
    },
  }

  public inside_sales_user_id: any = null

  public created_by_id: any = null

  public commentary: string = ''

  public amount_changes: OpportunityAmountChange[] = []

  public get companies() {
    let ids = []

    if (this.agency_id) ids.push(this.agency_id)
    if (this.advertiser_id) ids.push(this.advertiser_id)

    return ids
  }

  public get formAmount() {
    return this.amount
  }

  public set formAmount(val) {
    this.amount = Number(val)

    if (this.amount === 0) {
      this.metadata.product_revenue_distribution.ssl = 0
      this.metadata.product_revenue_distribution.ccl = 0
      this.metadata.product_revenue_distribution.home = 0
      return
    }

    if (this.types.length == 1) {
      if (this.types[0] == 'ssl') {
        this.metadata.product_revenue_distribution.ssl = this.amount
        this.metadata.product_revenue_distribution.ccl = 0
        this.metadata.product_revenue_distribution.home = 0
      } else if (this.types[0] == 'ccl') {
        this.metadata.product_revenue_distribution.ssl = 0
        this.metadata.product_revenue_distribution.ccl = this.amount
        this.metadata.product_revenue_distribution.home = 0
      } else {
        this.metadata.product_revenue_distribution.ssl = 0
        this.metadata.product_revenue_distribution.ccl = 0
        this.metadata.product_revenue_distribution.home = this.amount
      }
      return
    }

    let total = Number(this.metadata.product_revenue_distribution.ssl)
      + Number(this.metadata.product_revenue_distribution.ccl)
      + Number(this.metadata.product_revenue_distribution.home)

    if (total == 0) {
      val = new BigNumber(val)
      val = val.dividedBy(this.types.length).toNumber()

      for (let i = 0; i < this.types.length; i++) {
        this.metadata.product_revenue_distribution[this.types[i]] = val
      }
    } else {
      this.metadata.product_revenue_distribution.ssl = this.amount * (this.metadata.product_revenue_distribution.ssl / total)
      this.metadata.product_revenue_distribution.ccl = this.amount * (this.metadata.product_revenue_distribution.ccl / total)
      this.metadata.product_revenue_distribution.home = this.amount * (this.metadata.product_revenue_distribution.home / total)
    }
  }

  public get quarters() {
    const start_at = moment(this.start_at)
    const end_at = moment(this.end_at)

    return `Q${start_at.quarter()} ${start_at.year()} ~ Q${end_at.quarter()} ${end_at.year()}`
  }

  public close_reason: any = null

  public lost_category: any = null

  public rfp: any = null

  public lead_source: any = null

  public close_week_day: any = 'sunday'

  public mrg: any = null

  public max_avail_tasks: number = 0

  public media_plan_tasks: number = 0

  public is_forecast: boolean = false

  public get formTypes() {
    return this.types.map(v => v.toUpperCase()).join(', ')
  }

  // Check if object has changed
  public get is_dirty(): boolean {
    return this._hash !== this.calculateChecksum()
  }

  public get revenue_period() {
    if (this.start_at && this.end_at) {
      let start_at = moment(this.start_at)
      let end_at = moment(this.end_at)

      let ret = ''
      if (start_at.quarter() === end_at.quarter()) {
        ret = `Q${start_at.quarter()}`
      } else {
        ret = `Q${start_at.quarter()} - Q${end_at.quarter()}`
      }
      ret += ` (${moment(this.start_at).format('MMM, YYYY')} - ${moment(this.end_at).format(
        'MMM, YYYY',
      )})`

      return ret
    }
    return 'N/A'
  }

  public get final_status() {
    if (['won', 'processing'].includes(this.status)) {
      return 'won'
    }
    if (this.status === 'lost') {
      return 'lost'
    }
    return 'open'
  }

  public get status_color() {
    if (this.status === 'won') {
      return 'success'
    }
    if (this.status === 'lost') {
      return 'danger'
    }
    if (this.status === 'processing') {
      return 'info'
    }
    return 'secondary'
  }

  private _hash: string | Int32Array = ''

  private calculateChecksum(): string | Int32Array {
    let data = this.apiData

    return Md5.hashStr(JSON.stringify(data))
  }

  public updateChecksum() {
    this._hash = this.calculateChecksum()
  }

  public requestMaxAvails() {
    this.tasks.request_max_avail_plan = true
  }

  public requestMediaPlan() {
    this.tasks.request_media_plan = true
  }

  private _revenueScheduleCache: any = {
    product: null,
    teams: null,
  }

  public revenueScheduleChartData(view: string = 'product') {
    if (this._revenueScheduleCache[view] !== null) {
      return this._revenueScheduleCache[view]
    }

    let result: any = {
      series: [],
      categories: [],
      total: 0,
    }

    if (this.revenue_details === null || !this.revenue_details.detailed_revenue_distribution) {
      return result
    }

    if (this.revenue_details.monthly_revenue_distribution) {
      let total = 0
      for (let month in this.revenue_details.monthly_revenue_distribution) {
        total += this.revenue_details.monthly_revenue_distribution[month]
      }
      result.total = total
    }

    if (!this.revenue_details.detailed_revenue_distribution[view]) {
      return result
    }

    let ref = this.revenue_details.detailed_revenue_distribution[view]

    let products = Object.keys(ref)
    let periods = Object.keys(this.revenue_details.detailed_revenue_distribution.month)
      .map(m =>
        // parse aug_2024 to moment
        moment(m, 'MMM_YYYY'))
      .sort((a, b) => a.unix() - b.unix())

    // Create Labels
    periods.forEach(period => {
      result.categories.push(period.format('MMM, YYYY'))
    })

    for (let i = 0; i < products.length; i++) {
      let series = []
      for (let j = 0; j < periods.length; j++) {
        let month_key = periods[j].format('MMM_YYYY').toLowerCase()
        series.push(ref[products[i]].month[month_key] || 0)
        // result.total += ref[products[i]].month[month_key] || 0
      }

      let label = view === 'product' ? products[i].toUpperCase() : products[i]

      result.series.push({
        name: label,
        data: series,
      })
    }

    this._revenueScheduleCache[view] = result

    return result
  }

  public get apiData() {
    return {
      holding_id: this.holding_id,
      agency_id: this.agency_id,
      station_id: this.station_id,
      advertiser_id: this.advertiser_id,
      sales_management_id: this.sales_management_id,
      sales_rep_id: this.sales_rep_id,
      account_manager_id: this.account_manager_id,
      name: this.name,
      status: this.status,
      percentage: this.percentage,
      types: this.types,
      source: this.source,
      amount: this.amount,
      start_at: this.start_at,
      end_at: this.end_at,
      closed_at: this.closed_at,
      company_contact_ids: this.company_contact_ids,
      preplan_ids: this.preplan_ids,
      media_plan_ids: this.media_plan_ids,
      activities: this.activities,
      tasks: this.tasks,
      close_reason: this.close_reason,
      lost_category: this.lost_category,
      rfp: this.rfp,
      lead_source: this.lead_source,
      close_week_day: this.close_week_day,
      mrg: this.mrg,
      metadata: this.metadata,
      main_media_plan_id: this.main_media_plan_id,
      original_amount: this.original_amount,
      is_cancelled: this.is_cancelled,
      is_forecast: this.is_forecast,
      force_new_business: this.force_new_business,
      amount_changes: this.amount_changes.map(r => r.apiData),
      inside_sales_user_id: this.inside_sales_user_id,
      force_new_account: this.force_new_account,
      is_political: this.is_political,
      media_plan_overwrite: this.media_plan_overwrite,
      commentary: this.commentary,
      created_by_id: this.created_by_id,
      secondary_sales_rep_ids: this.secondary_sales_rep_ids,
      teams: this.teams,
    }
  }

  public toObject(payload: any): this {
    // added this to avoid mutating the original object which is causing issues
    // it was deleting the start_at and end_at properties from the original object and also deleting from instance
    let source = { ...payload }

    let instance = this.clone()

    if (source.start_at) {
      instance.start_at = source.start_at.includes('T')
        ? source.start_at.split('T')[0]
        : moment(source.start_at).format('YYYY-MM-DD')
    }

    if (source.end_at) {
      instance.end_at = source.end_at.includes('T')
        ? source.end_at.split('T')[0]
        : moment(source.end_at).format('YYYY-MM-DD')
    }

    if (source.closed_at) {
      instance.closed_at = source.closed_at.includes('T')
        ? source.closed_at.split('T')[0]
        : moment(source.closed_at).format('YYYY-MM-DD')
    }

    if (source.activities) {
      instance.activities = OpportunityActivity.toObjectList(source.activities)
    }

    if (source.files) {
      instance.files = ModelFile.toObjectList(source.files)
    }

    instance.metadata = {
      ...instance.metadata,
      ...source.metadata,
    }

    if (!source.secondary_sales_rep_ids) {
      source.secondary_sales_rep_ids = []
    } else {
      // add .new = false
      source.secondary_sales_rep_ids = source.secondary_sales_rep_ids.map((obj: any) => ({
        ...obj,
        new: false,
      }))
    }

    delete source.start_at
    delete source.end_at
    delete source.closed_at
    delete source.metadata
    delete source.activities

    Object.assign(instance, source)

    if (source.close_week_day === null) {
      instance.close_week_day = 'sunday'
    }

    /**
     * This was added due to the fact that the properties below are changed on set formAmount and
     * on page load this model has is_dirty = true
     */
    instance.formAmount = Number(instance.amount)

    setTimeout(() => {
      instance.updateChecksum()
    }, 500)

    return instance
  }

  public static buildQuery(payload: any) {
    let api = new Api()
    return api.post('opportunities/report', payload)
  }

  public static buildAdvancedQuery(payload: any) {
    let api = new Api()
    return api.post('opportunities/advanced-report', payload)
  }

  public static weeklyCard(payload: any) {
    let api = new Api()
    return api.post('opportunities/weekly-card', payload)
  }

  public static weekPipeline(payload: any) {
    let api = new Api()
    return api.post('opportunities/weekly-pipeline', payload)
  }

  public static exportWeekClosedOpportunities(payload: any) {
    let api = new Api()
    return api.post('opportunities/weekly-closed-export', payload)
  }

  public getHistory(options: PaginateOptions) {
    const api = new Api()
    return api.post(`opportunity/${this.id}/history`, options)
  }

  public static forceStatusUpdate(payload: any, prop: string | string[]) {
    let api = new Api()
    const data: any = {}

    if (Array.isArray(prop)) {
      prop.forEach(p => {
        data[p] = payload[p]
      })
    } else {
      data[prop] = payload[prop]
    }

    return api
      .post(`opportunities-update-status/${payload.id}`, data)
      .then(() => {
        WebMessage.success('Opportunity updated successfully')
      })
      .catch((error: any) => {
        throw error
      })
  }

  public static force_new_account_options: SelectOption[] = [
    new SelectOption('Auto', 'auto'),
    new SelectOption('Yes', 'yes'),
    new SelectOption('No', 'no'),
  ]

  /**
   * actions
   */

  public cant_be_saved: boolean = false

  public checking_media_plan: boolean = false

  public hide_footer: boolean = false

  public check_media_plan: boolean = false

  public media_plan: MediaPlan | null = null

  public resetStatusCheck() {
    this.check_media_plan = false
    this.checking_media_plan = false
    this.hide_footer = false
    this.media_plan = null
    this.cant_be_saved = false
  }

  public async changeStage({
    code,
    value,
    reason,
  }: {
    code: string
    value: number
    reason?: boolean
  }) {
    //
    let automated_status = ['won', 'lost']

    if (automated_status.includes(this.status)) {
      WebMessage.warning(
        'The status can not be updated, it will be automatically updated with the media plan.',
      )
      return false
    }

    if (code === 'won') {
      WebMessage.warning(
        'Can not set to Won, the status will be automatically updated once the media plan is confirmed or canceled.',
      )
      return false
    }

    if (code !== 'lost') {
      this.percentage = value
      this.status = code
      return true
    }
    return await this.checkMediaPlanOnLost({
      code,
      value,
      reason,
    })
  }

  public async checkMediaPlanOnLost({
    code,
    value,
    reason,
  }: {
    code: string
    value: number
    reason?: boolean
  }) {
    if (this.main_media_plan_id) {
      this.check_media_plan = true
      this.checking_media_plan = true
      this.hide_footer = true
    } else {
      return true
    }
    const response = await MediaPlan.find(this.main_media_plan_id)
    this.checking_media_plan = false
    this.media_plan = response

    if (
      response.hasOwnProperty('metrics')
      && response.metrics.hasOwnProperty('impressions')
      && response.metrics.impressions > 0
    ) {
      this.cant_be_saved = true
      this.checking_media_plan = false
      return false
    }
    this.cant_be_saved = false
    this.hide_footer = false
    this.check_media_plan = reason || false
    this.percentage = value
    this.status = code
    return true
  }
}
